export const GA_EVENTS = {
    RWC_SECTION_ENTERED: {
        event: "rwc_section_entered",
        eventCategory: "RWC_landing_page",
        eventAction: "section_name",
        eventLabel: "header"
    }
};
